__turbopack_context__.v({
  "InputSelect--lg": "_-module__Vru6xq__InputSelect--lg",
  "InputSelect--md": "_-module__Vru6xq__InputSelect--md",
  "InputSelect--sm": "_-module__Vru6xq__InputSelect--sm",
  "InputSelectIcon": "_-module__Vru6xq__InputSelectIcon",
  "InputSelectItem": "_-module__Vru6xq__InputSelectItem",
  "InputSelectItem--negative": "_-module__Vru6xq__InputSelectItem--negative",
  "InputSelectTrigger": "_-module__Vru6xq__InputSelectTrigger",
  "group": "_-module__Vru6xq__group",
});
